export enum CartAvailabilityStatus {
  AVAILABLE = "AVAILABLE",
  PRICE_CHANGED = "PRICE_CHANGED",
  UNAVAILABLE = "UNAVAILABLE",
  BOOKED = "BOOKED",
  FAILED_BOOKING = "FAILED_BOOKING",
  REFUNDED = "REFUNDED",
}

export enum CartStatus {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
}

export enum CartTransactionStatus {
  PENDING = "PENDING",
  FAILED = "FAILED",
  SUCCESS = "SUCCESS",
  FULL_REFUND = "FULL_REFUND",
  PARTIAL_REFUND = "PARTIAL_REFUND",
}
